import { ROLES, ALL_PAGE_ACCESS_ROLES, hasAnyRole } from 'config/roles';
import { videoSlide } from 'components/v3/onboarding/OnboardingSlideElements';
import { networkSlides } from 'components/v3/onboarding/OnboardingSlidesNetwork';
import { storeSlides } from 'components/v3/onboarding/OnboardingSlidesStore';
import { warehouseSlides } from 'components/v3/onboarding/OnboardingSlidesWarehouse';
import { regionSlides } from 'components/v3/onboarding/OnboardingSlidesRegion';
import { partnerSlides } from 'components/v3/onboarding/OnboardingSlidesPartner';

// ==========================================
// 🎥 SLIDE VIDÉO
// La vidéo actuelle présente le dashboard V2 (ancienne arborescence) : elle est
// donc en décalage avec les pages décrites ci-dessous. Passer ce drapeau à true
// une fois la nouvelle vidéo V3 tournée et son ID renseigne dans
// OnboardingVideoPlayer.js.
// ==========================================
const SHOW_VIDEO_SLIDE = false;

/**
 * PROFILS DE TUTORIEL
 *
 * Le dashboard n'affiche pas les memes pages selon le role de l'utilisateur
 * (cf. ROUTE_CONFIG + Menu v3). Le tutoriel suit la meme logique : chaque profil
 * ne voit que les slides des pages auxquelles il a effectivement acces.
 *
 * Correspondance role -> profil (le premier match gagne, comme ROLE_LANDING_MAP) :
 *   mobiuspack-admin / account-manager / project-manager -> NETWORK
 *   store-manager                                        -> STORE
 *   warehouse-manager                                    -> WAREHOUSE
 *   group-manager                                        -> REGION
 *   partner                                              -> PARTNER
 *
 * Le contenu de chaque profil vit dans son propre fichier (OnboardingSlides{Profil}.js),
 * les atomes de style et les slides communes dans OnboardingSlideElements.js.
 */
const PROFILES = {
    NETWORK: 'network',
    STORE: 'store',
    WAREHOUSE: 'warehouse',
    REGION: 'region',
    PARTNER: 'partner',
};

const resolveProfile = (userRoles = []) => {
    if (hasAnyRole(userRoles, ALL_PAGE_ACCESS_ROLES)) return PROFILES.NETWORK;
    if (hasAnyRole(userRoles, [ROLES.STORE_MANAGER.id])) return PROFILES.STORE;
    if (hasAnyRole(userRoles, [ROLES.WAREHOUSE_MANAGER.id])) return PROFILES.WAREHOUSE;
    if (hasAnyRole(userRoles, [ROLES.GROUP_MANAGER.id])) return PROFILES.REGION;
    if (hasAnyRole(userRoles, [ROLES.PARTNER.id])) return PROFILES.PARTNER;
    return PROFILES.NETWORK;
};

const SLIDES_BY_PROFILE = {
    [PROFILES.NETWORK]: networkSlides,
    [PROFILES.STORE]: storeSlides,
    [PROFILES.WAREHOUSE]: warehouseSlides,
    [PROFILES.REGION]: regionSlides,
    [PROFILES.PARTNER]: partnerSlides,
};

/**
 * Retourne les slides du tutoriel d'onboarding adaptees au role de l'utilisateur.
 *
 * @param {string[]} userRoles - Roles de l'utilisateur connecte (user.roles, meme
 *                               source que le menu). Sans roles, on retombe sur le
 *                               parcours le plus complet (NETWORK).
 * @returns {Array} - Tableau de slides { title, content }
 */
export const getOnboardingSlides = (userRoles = []) => {
    const profile = resolveProfile(userRoles);
    const slides = (SLIDES_BY_PROFILE[profile] || networkSlides)();

    if (!SHOW_VIDEO_SLIDE) return slides;

    // La video s'intercale juste apres l'accueil.
    return [slides[0], videoSlide(), ...slides.slice(1)];
};
